import { FounderActivationBlockedReason } from './FundPersonDtoOut';

export const LEAD_COORDINATORS_TO_REVIEW_URL = 'management/lead-coordinators-to-review';

/**
 * «רכזים ראשיים לבדיקה» (29.10.2026): a lead coordinator held back because the Israeli ID on their
 * account is on a record that names someone else. For the office only - it carries the ID.
 */
export interface LeadCoordinatorToReviewDtoOut {
  fundId: number;
  fundName: string | null;
  email: string;
  firstName: string | null;
  lastName: string | null;
  israeliId: string | null;
  reason: FounderActivationBlockedReason | null;
  recordContactId: number | null;
  recordFirstName: string | null;
  recordLastName: string | null;
  recordEmail: string | null;
  recordSupportedInFunds: number[];
  recordRepresentsFunds: number[];
}

export interface LeadCoordinatorReviewDtoIn {
  fundId: number;
  email: string;
  israeliId?: string;
}
